import React from 'react';

const ProductFeatures = props => {

  return (
    <section className="product-features">
      <h1>Our Features</h1>
      <div className="core-features">
        <div className="core-feature-1">
          <div className="core-feature-1-image">
            <svg className="product-feature-1-image" />
          </div>
          <h2>Ascending unconventional wisdom.</h2>
          <p>Pipory is focused purely in creativity and self-expression. Create, 
            learn and get inspired by people with similar interests and aspirations. 
          </p>
        </div>
        <div className="core-feature-3">
          <div className="core-feature-3-image">
            <svg className="product-feature-2-image" />
          </div>
          <h2>Presentation Matters</h2>
          <p>Mesmerizing templates and high fidelity editor to provide your 
            work the attention it deserves. Editable backgrounds, Various Fonts 
            & a clean user interface to suit your creativity.
          </p>
        </div>
        <div className="core-feature-2">
          <div className="core-feature-1-image">
            <svg className="product-feature-3-image" />    
          </div>
          <h2>Attract and Get Attracted</h2>
          <p>Follow, connect and collaborate with a community of poets 
            and photographers to learn, get inspired & expand your audience.
          </p>
        </div>
      </div>
      <br></br>
    </section>
  )
};

export default ProductFeatures;
